@use '@lib/assets/styles/main.scss' as *;

.sitesGrid {
  @extend .row;
  margin-left: -8px;
  margin-right: -8px;
  & > div {
    @extend .col-xs-12, .col-md-4;
    padding-left: 8px;
    padding-right: 8px;
    margin-bottom: 16px;
  }
}

.pagination {
  background-color: $gray0;
}
